<template>
  <footer class="relative">
    <div class="bg-blueDianne pb-10 font-headline">
      <div class="container py-8 max-w-[1200px] px-3 lg:px-10 sm:mx-auto">
        <div class="flex flex-wrap sm:justify-between justify-center">
          <div class="w-full sm:w-2/3 md:w-3/4 pl-4 sm:pl-8 sm-pt:0">
            <div class="flex">
              <div class="footer-icon w-[15px] h-[15px] mt-2">
                <svg viewBox="0 0 21 22" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21.01 0.189941V21.1602H15.43V9.70996L7.34003 17.7998L3.40002 13.8701L11.49 5.75977H0.039978V0.189941H21.01Z"
                  ></path>
                </svg>
              </div>
              <div class="ml-3">
                <h4 class="font-bold text-xl text-white">Who We Are</h4>
                <ul
                  class="flex flex-col flex-wrap list-none sm:justify-end justify-center text-white"
                >
                  <li class="mt-3">
                    <a :href="`${marketingBaseUrl}/about-us`"
                      ><span class="py-3 md:py-1 block">About Us</span></a
                    >
                  </li>
                  <li class="mt-3">
                    <a :href="`${marketingBaseUrl}/get-started`"
                      ><span class="py-3 md:py-1 block">Get Started</span></a
                    >
                  </li>
                  <li class="mt-3">
                    <a :href="`${marketingBaseUrl}/contact-us`"
                      ><span class="py-3 md:py-1 block">Contact Us</span></a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="w-full sm:w-1/3 md:w-1/4 px-4 sm:px-8 text-white">
            <div>
              <a
                :href="`${marketingBaseUrl}`"
                class="text-white text-sm font-bold leading-relaxed inline-block whitespace-nowrap uppercase"
              >
                <img
                  src="/img/notedsource-logo-footer.svg"
                  width="288"
                  height="42"
                  alt="NotedSource"
                />
              </a>
              <p class="text-sm mt-5">
                222 Broadway<br />
                22nd Floor<br />
                New York, NY 10038<br />
              </p>
              <p class="text-sm mt-5">
                © {{ date }}
                <a class="text-puertoRico" :href="marketingBaseUrl"
                  >NotedSource</a
                >
              </p>
              <p class="text-xs mt-5">
                <a :href="`${webBaseUrl}/terms`"
                  ><span class="py-3 md:py-1">Terms of Use</span></a
                >
                &nbsp;|&nbsp;
                <a :href="`${webBaseUrl}/privacy`"
                  ><span class="py-3 md:py-1">Privacy Policy</span></a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      date: new Date().getFullYear(),
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
      marketingBaseUrl: import.meta.env.VITE_BASE_URL,
    };
  },
  mounted() {
    if (
      import.meta.env.VITE_GOOGLE_ADS_ID &&
      this.$hj &&
      !import.meta.env.SSR &&
      !window.doNoTrack
    ) {
      const gclidPromise = new Promise((resolve) => {
        window.gtag(
          "get",
          import.meta.env.VITE_GOOGLE_ADS_ID,
          "gclid",
          resolve,
        );
      });
      gclidPromise.then((gclid) => {
        if (gclid) {
          this.$hj("event", "google_cpc");
        }
      });
    }
    if (this.$hj) {
      this.$hj("event", `session_referrer_${window.document.referrer}`);
    }
  },
};
</script>

<style lang="scss" scoped>
.footer-icon svg path {
  fill: #2ecfae;
}
</style>
